import {
  SAVE_FUEL_SAVINGS,
  CALCULATE_FUEL_SAVINGS
} from '../actions/actionTypes';
import {
  necessaryDataIsProvidedToCalculateSavings,
  calculateSavings
} from '../utils/fuelSavings';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// We're using Object spread to create a copy of current state
// and update values on the copy.
export default function fuelSavingsReducer(
  state = initialState.fuelSavings,
  action
) {
  let newState;

  switch (action.type) {
    case SAVE_FUEL_SAVINGS:
      return { ...state, dateModified: action.dateModified };

    case CALCULATE_FUEL_SAVINGS:
      newState = {
        ...state,
        [action.fieldName]: action.value,
        dateModified: action.dateModified,
        savings: {
          monthly: '',
          annual: '',
          threeYear: ''
        }
      };

      newState.necessaryDataIsProvidedToCalculateSavings = necessaryDataIsProvidedToCalculateSavings(
        newState
      );

      if (newState.necessaryDataIsProvidedToCalculateSavings) {
        newState.savings = calculateSavings(newState);
      }

      return newState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fuelSavingsReducer.js